export class AppPermissions {
  private static readonly BasePermission = 'HourReportEntry';
  static readonly HourActivityReport = `${AppPermissions.BasePermission}.HourActivityReport`;
}
